import isEqual from 'lodash/isEqual'

// Reading and clearing one list filter in the filters object of a list (tasks#211). A field is a
// TableFilters filter: { key, type?, other? } or a date range pill { start, end }.

function read(value, key, type) {
    return type ? value[key]?.[type] : value[key]
}

function clear(value, key, type) {
    if (!type) {
        delete value[key]
        return
    }
    if (!value[key]) return
    delete value[key][type]
    if (!Object.keys(value[key]).length) delete value[key]
}

// the (key, type) places in the filters object that the field writes
export function filterSlots(field) {
    if (field.inputType === 'daterange')
        return [field.start, field.end].map((f) => [f.key, f.type])
    const slots = [[field.key, field.type]]
    if (field.other) slots.push([field.other.key, field.other.type])
    return slots
}

export function readFilter(value, field) {
    if (field.inputType === 'location')
        return field.other ? value[field.other.key] : undefined
    if (field.inputType === 'daterange')
        return read(value, field.start.key, field.start.type)
    return read(value, field.key, field.type)
}

// the end of a date range; the list can come with one end only
export function readRangeEnd(value, field) {
    if (field.inputType !== 'daterange') return undefined
    return read(value, field.end.key, field.end.type)
}

export function isFilterActive(value, field) {
    // a checkbox is on only while its own value (and its pair, Today = after + before) is set
    if (field.inputType === 'checkbox') {
        const matches = (key, type, expected) =>
            expected === undefined
                ? Boolean(read(value, key, type))
                : isEqual(read(value, key, type), expected)
        return (
            matches(field.key, field.type, field.value) &&
            (!field.other ||
                matches(field.other.key, field.other.type, field.other.value))
        )
    }
    if (readRangeEnd(value, field)) return true
    const current = readFilter(value, field)
    if (Array.isArray(current)) return current.length > 0
    return current !== undefined && current !== null && current !== ''
}

// a copy of the filters without the given fields
export function withoutFilters(value, fields) {
    const result = JSON.parse(JSON.stringify(value))
    fields.forEach((field) =>
        filterSlots(field).forEach(([key, type]) => clear(result, key, type))
    )
    return result
}

// the fields' part of the filters, to compare two filter states
export function pickFilters(value, fields) {
    const picked = {}
    fields.forEach((field) =>
        filterSlots(field).forEach(([key, type]) => {
            const current = read(value, key, type)
            if (current !== undefined) picked[`${key}.${type || ''}`] = current
        })
    )
    return picked
}
